import React from 'react';
import { getIn } from 'formik';
import Input from '@/components/shared/Input';
import { IMultiStepSignupValues } from './types';
import { UserRole } from '@/types';
import './MultiStepSignupStep2.scss';

const baseClass = 'MultiStepSignupStep2';

interface Props {
  userRole: UserRole;
  values: IMultiStepSignupValues;
  errors: any;
  touched: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  setFieldValue: (field: string, value: any) => void;
}

const MultiStepSignupStep2: React.FC<Props> = ({
                                                 userRole,
                                                 values,
                                                 errors,
                                                 touched,
                                                 handleChange,
                                                 handleBlur,
                                                 setFieldValue,
                                               }) => {
  // Цей крок тільки для manager
  if (userRole !== UserRole.MANAGER) {
    return null;
  }

  return (
    <div className={baseClass}>
      <div className={`${baseClass}__header`}>
        <h2 className={`${baseClass}__title`}>Work Information</h2>
      </div>

      <div className={`${baseClass}__form-group`}>
        {/* Company Name */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.companyName || ''}
          name="companyName"
          type="text"
          label="Company name"
          errors={getIn(errors, 'companyName') || ''}
        />

        {/* Department */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.department || ''}
          name="department"
          type="text"
          label="Department"
          errors={getIn(errors, 'department') || ''}
        />

        {/* Job Title */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.jobTitle || ''}
          name="jobTitle"
          type="text"
          label="Job title"
          errors={getIn(errors, 'jobTitle') || ''}
        />
      </div>
    </div>
  );
};

export default MultiStepSignupStep2;